import React from 'react';
import { CpIcon } from 'canopy-styleguide!sofe';
import { track } from '../analytics.helper'

export default function ClientMenuLinks(props) {
  const {customLinks, companyWebsiteLink, showBorder} = props

  return (
    <>
      {!!showBorder && <hr />}
      <div>
        {!!companyWebsiteLink?.enabled && (
          <a
            href={companyWebsiteLink.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>track('third-party-link_clicked', { linkClicked: 'Website' })}
          >
            <CpIcon className='cp-select-list__icon-left' name="misc-globe"/>
            <span className='cps-ellipsis'>{companyWebsiteLink.link}</span>
          </a>
        )}
        {customLinks?.length > 0 && customLinks.map(({link, link_label}) => (
          <a
            href={link}
            key={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>track('third-party-link_clicked', { linkClicked: 'Custom' })}
          >
            <CpIcon className='cp-select-list__icon-left' name="af-external-link"/>
            <span className='cps-ellipsis'>{link_label || link}</span>
          </a>
        ))}
      </div>
      <hr />
    </>
  )
}
